import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { SIPProvider } from 'react-sipjs';
import type { SIPProviderOptions } from 'react-sipjs/dist/type';
import VICIDialCallComponent from './VICIDialCallComponent';

interface VICIDialProps {
    sipConfig?: Partial<SIPProviderOptions>;
    call?: any;
    user?: any;
}

const VICIDial: React.FC<VICIDialProps> = ({ sipConfig, call, user }) => {
    const [config, setConfig] = useState<SIPProviderOptions | null>(null);

    useEffect(() => {
        const defaultConfig: SIPProviderOptions = {
            domain: process.env.REACT_APP_VICIDIAL_DOMAIN || 'your-vicidial-server.com',
            webSocketServer: process.env.REACT_APP_VICIDIAL_WS_SERVER || 'wss://your-vicidial-server.com:8089/ws',
        };

        const finalConfig: SIPProviderOptions = {
            ...defaultConfig,
            ...(sipConfig || {}),
        };

        setConfig(finalConfig);
    }, [sipConfig, call, user]);

    if (!config) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh',
                }}
            >
                <Typography>Loading SIP Configuration...</Typography>
            </Box>
        );
    }

    return (
        <SIPProvider options={config}>
            <VICIDialCallComponent call={call} user={user} sipConfig={config} />
        </SIPProvider>
    );
};

export default VICIDial;
